import { LineSeparatorPositionType } from '@kubit/web-ui-components/lineSeparator/types';
import { css } from 'styled-components';
export const lineSeparatorStyledBuild = ({ border_color, border_weight }) => (position) => {
    switch (position) {
        case LineSeparatorPositionType.BOTTOM:
            return css `
          border-bottom-style: solid;
          border-bottom-width: ${border_weight};
          border-bottom-color: ${border_color};
        `;
        case LineSeparatorPositionType.LEFT:
            return css `
          border-left-style: solid;
          border-left-width: ${border_weight};
          border-left-color: ${border_color};
        `;
        case LineSeparatorPositionType.RIGHT:
            return css `
          border-right-style: solid;
          border-right-width: ${border_weight};
          border-right-color: ${border_color};
        `;
        default:
            return css `
          border-top-style: solid;
          border-top-width: ${border_weight};
          border-top-color: ${border_color};
        `;
    }
};
//# sourceMappingURL=commonStyles.js.map